module.exports = __webpack_public_path__ + "images/icons/icon-card-collapsed-6ab413cb.svg";